export default __webpack_public_path__ + "static/media/slider-debt.44f3098c.png";